import { Component, computed, input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import { LinkField, RichTextField, TextField } from '@core/jss-proxy';
import { SimpleTableComponent } from '@content/ui/simple-table';
import { getField } from '@core/jss-utils';
import {
  computedContentSectionTheme,
  ContentSectionComponent,
} from '@core/content-section';

@Component({
  selector: 'wl-simple-table-container',
  templateUrl: './simple-table.container.component.html',
  standalone: true,
  imports: [ContentSectionComponent, SimpleTableComponent],
})
export class SimpleTableContainerComponent {
  readonly rendering = input.required<InnogyComponentRendering>();
  readonly theme = computedContentSectionTheme(this.rendering);

  readonly fields = computed(() => this.rendering().fields);
  readonly title = computed(() => getField<TextField>(this.fields(), 'Title'));
  readonly introduction = computed(() =>
    getField<TextField>(this.fields(), 'Introduction')
  );
  readonly table = computed(() =>
    getField<RichTextField>(this.fields(), 'Table')
  );
  readonly callToAction = computed(() =>
    getField<LinkField>(this.fields(), 'CallToAction')
  );
}
